import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    invalidTargetProject: string;
    moveFailed: (assetCount: number) => string;
    moveDenied: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error shown when a move crosses between regular and managed project storage, in either direction. */
            invalidTargetProject: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useBulkMoveAssets.invalidTargetProject?c=29ywe52sgopsz", defaultMessage: "Moving assets between regular and managed projects isn''t supported yet." }));
                },
                enumerable: true,
                configurable: true
            },
            moveFailed: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (assetCount: number): string => __intl__.intl().formatMessage({ id: "useBulkMoveAssets.moveFailed?c=2md2zwl1py1tu", defaultMessage: "Failed to move {assetCount} items" }, { assetCount: assetCount }));
                },
                enumerable: true,
                configurable: true
            },
            moveDenied: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useBulkMoveAssets.moveDenied?c=h3doadhzgkjz", defaultMessage: "You don''t have permission to move these items." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
